export enum ModalSize {
    STANDARD = 'default',
    LARGE = 'lg'
}